$(document).ready(function(){
  
  var now = new Date();
  var formattedDateTime = now.toLocaleString();
  console.log(formattedDateTime);

  function resetQuizState() {
    $(".quiz-banner-section").show();
    $("body").removeClass("quiz-start");
    $("body").removeClass("results-showing");
    $(".quiz-flow-step").hide();
    $(".quiz-flow-step").find("input").prop("checked", false);
    $(".next-button").not(".quiz-skip-button").attr("disabled", "disabled");
    $(".global-prev-button-wrapper").hide();
    $(".results-main").html("");
    $(".quiz-flow-step").removeClass("step-in-use");
    $(".custom-quiz-flow").hide();
  }

  function preLoadQuiz() {
    const $modalContent = $('#QuizModalContent');
    if ($modalContent.length > 0 && $modalContent.find('.custom-quiz-section').length === 0) {
      let url = $('#QuizModalTrigger').attr('data-url') || '/pages/quiz';
      if (url === '#') url = '/pages/quiz';
      
      $.get(url, function(data) {
        const $temp = $('<div>').append($.parseHTML(data));
        const $quizSection = $temp.find('.custom-quiz-section');
        if ($quizSection.length > 0) {
          $modalContent.html($quizSection);
          resetQuizState();
        }
      });
    }
  }

  preLoadQuiz();

  // Quiz Modal Trigger logic
  $(document).on('click', '#QuizModalTrigger', function(e) {
    e.preventDefault();
    const modal = document.querySelector('#PopupModal-Quiz');
    if (modal) {
      if (typeof modal.show === 'function') {
        modal.show(this);
      } else {
        // Fallback if component is not yet fully initialized
        modal.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
      }
      resetQuizState();
    }
  });

  // Ensure body cleanup when modal closes (outside click, esc, or close button)
  const modal = document.querySelector('#PopupModal-Quiz');
  if (modal) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (!modal.hasAttribute('open')) {
            resetQuizState();
            document.body.classList.remove('overflow-hidden');
          }
        }
      });
    });
    observer.observe(modal, { attributes: true });
  }

  // Handle Close Button specifically for modal behavior if needed
  $(document).on('click', '#ModalClose-Quiz', function() {
    resetQuizState();
  });

  $(".quiz-flow-step").find("input").prop("checked", false);
  $(".next-button").not(".quiz-skip-button").attr("disabled", "disabled");
  
  if (sessionStorage.getItem("quiz_form_submitted") !== "true") {
    $(".newsletter__message--error").hide();
  }
  sessionStorage.removeItem("quiz_form_submitted");

  $(document).on("click", "button.start-quiz", function(){
    $(".quiz-banner-section").hide();
    $(".custom-quiz-flow").show();
    $("body").addClass("quiz-start");
    $(".quiz-flow-step[step-count='1']").show();
    $(".quiz-flow-step[step-count='1']").addClass("step-in-use");
    $(".global-prev-button-wrapper").show();

    // Reset skip buttons visibility
    $(".quiz-skip-button").css({"visibility": "hidden", "opacity": "0"});
    // Delay skip button appearance for the first step
    setTimeout(function() {
      $(".quiz-flow-step[step-count='1']").find(".quiz-skip-button").css({"visibility": "visible", "opacity": "1"});
    }, 8000);
  })

  $(document).on("click", "button.quiz-exit", function(){
    // If inside a modal, we might want to close the modal too
    const $modal = $(this).closest('modal-dialog');
    if ($modal.length > 0) {
      $modal[0].hide(); // Assuming the modal-dialog has a hide method
    }
    resetQuizState();
  })

  $(document).on("click", ".back-to-remove-results", function(){
    $(".results-main").html("")
  });

  $(document).on("click", "label.option-container-in", function(e){
    var $input = $(this).find("input");
    var $parent = $(this).parents(".quiz-flow-step");
    $parent.find("button.next-button").removeAttr("disabled"); 
    
    // Auto-advance logic
    setTimeout(function() {
      $parent.find("button.next-button").trigger("click");
    }, 400);
  });

  function switchStep(targetStep, direction) {
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        performStepSwitch(targetStep, direction);
      });
    } else {
      performStepSwitch(targetStep, direction);
    }
  }

  function performStepSwitch(get, direction) {
    const $target = $(".quiz-flow-step[step-count='"+get+"']");
    
    // Reset skip buttons visibility
    $(".quiz-skip-button").css({"visibility": "hidden", "opacity": "0"});

    if (direction === 'next') {
      $target.show().addClass("step-in-use");
      $target.prevAll(".quiz-flow-step").hide();
      $target.nextAll(".quiz-flow-step").hide();
    } else {
      $target.show().addClass("step-in-use");
      $target.nextAll(".quiz-flow-step").removeClass("step-in-use").hide();
      $target.prevAll(".quiz-flow-step").hide();
    }

    // Delay skip button appearance
    setTimeout(function() {
      $target.find(".quiz-skip-button").css({"visibility": "visible", "opacity": "1"});
    }, 6000); // 8 seconds delay
  }

  $(document).on("click", "button.next-button", function(){
    var get = $(this).attr("data-step");
    switchStep(get, 'next');
  })

  $(document).on("click", "button.prev-button", function(){
    var get = $(this).attr("data-step");
    if ($(this).hasClass('quiz-landing-back')) {
       resetQuizState();
       return;
    }
    switchStep(get, 'prev');
  })

  $(document).on("click", ".global-prev-button", function(){
    $(".quiz-flow-step:visible .prev-button").not(".global-prev-button").trigger("click");
  });

  var options = [];
  var results = [];

  $(document).on("click", ".final-result-call", function(){
    $("#quiz-kit-spinner").show();
    $(".hide-when-load").show();
    options = [];
    
    $(".step-in-use").each(function(){
      var get = $(this).find("input:checked").val();
      if(get) options.push(get);
    })

    var text = options.join("+");
    var first = $(".quiz-flow-step.step-in-use[step-count='1']").find("input:checked").val();
    var second = $(".quiz-flow-step.step-in-use[step-count='2']").find("input:checked").val();
    
    if (!first || !second) {
       console.error("Missing required steps for results");
       $("#quiz-kit-spinner").hide();
       return;
    }

    var sectionID = first.toLowerCase() + "-" + second.toLowerCase();
    
    $.ajax({
        url: '/?sections='+sectionID,
        type: 'GET',
        async:true,
        dataType:"json",
        success: function(data) {
          const htmlContent = data[sectionID];
          $("#quiz-kit-spinner").hide();
          $(".hide-when-load").hide();
          $(".results-main").html(htmlContent);
          $(".result-product-bar[result-match='"+text+"']").show();
          $("body").addClass("results-showing");
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error fetching results:", errorThrown);
          $("#quiz-kit-spinner").hide();
        }
      });
    $(".global-prev-button-wrapper").hide();
  })

  $(document).on("click", ".custom-newsletter-submit", function(e){
    var $form = $(this).parents("form");
    var getemail = $form.find("input[type='email']").val();        
    
    if (getemail != "") { 
      e.preventDefault();
      if(!isValidEmailAddress(getemail)) {
       var $emailInput = $form.find("input[type='email']");

        $emailInput[0].setCustomValidity("Please enter a valid email address");
        $emailInput[0].reportValidity();

        $emailInput.addClass("error").focus();

        return false;
              } else {
                $(this).find(".button-submit-text").hide();
                $(this).find(".spinner-buttom").show();
        
        options = [];
        results = [];
        $(".step-in-use").each(function(){
          var get = $(this).find("input:checked").val();
          if(get) options.push(get);
        });

        var text = options.join("+");
        var first = $(".quiz-flow-step.step-in-use[step-count='1']").find("input:checked").val().toLowerCase();
        var second = $(".quiz-flow-step.step-in-use[step-count='2']").find("input:checked").val().toLowerCase();
        var sectionID = first + "-" + second;

        $.ajax({
          url: '/?sections='+sectionID,
          type: 'GET',
          async:true,
          dataType:"json",
          success: function(data) {
            const htmlContent = data[sectionID];
            $(".results-main").html(htmlContent);
            $(".result-product-bar[result-match='"+text+"']").find(".prodiucts-bar .grid-item.product-item").each(function(){
              var title = $(this).find("p.product-item__title").text();
              results.push(title);
            });

            $.ajax({
              type:"post",
              url:"https://apikovessentials.com/kove-klaviyo/index.php?email="+getemail+"&date="+formattedDateTime+"&result="+results,
              async: true,
              headers: {
                "content-type": "application/json",
                "Access-Control-Allow-Origin": '*',
                "cache-control": "no-cache"
              },    
              crossDomain: true,
              success: function(data) {
                $(".button-submit-text").text("Subscribed");
                setTimeout(function(){
                  $(".button-submit-text").text("Submit & See Results").show();
                  $(".spinner-buttom").hide();
                  $(".final-result-call").trigger("click");
                }, 500);
              },
              error: function(xhr, status, error) {
                $(".button-submit-text").text("Subscribed").show();
                $(".spinner-buttom").hide();
                $(".final-result-call").trigger("click");
              }
            });
          }
        });
      }
    } else {
      e.preventDefault();

      var $emailInput = $form.find("input[type='email']");

      $emailInput.addClass("error");

      $emailInput[0].setCustomValidity("Please enter a valid email address");
      $emailInput[0].reportValidity();

      $emailInput.focus();

      return false;
      }
  });

  function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
  };

  $(document).on('click','.result-product-bar .swatches.swatch__button',function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).find(".sibling__link").addClass("sibling__link--current");
    $(this).siblings().find(".sibling__link").removeClass("sibling__link--current");
    
    var getImage = $(this).attr("data-sibling-image");
    var getPrice = $(this).attr("data-sibling-price");
    var getTitle = $(this).attr("variant-title");
    var getVariantId = $(this).attr("vriant-id");
    var getPurl = $(this).attr("data-sibling-url");
    
    var $gridItem = $(this).parents(".grid-item");
    $gridItem.find("p.product-item__title").text(getTitle);
    $gridItem.find("p.product-item__title span.new-price").text(getPrice);
    $gridItem.find("quick-add-product input[name='id']").val(getVariantId);
    $gridItem.find(".product-item__bg figure.image-wrapper img").attr("srcset",getImage);
    $gridItem.find(".product-item__image a.product-link").attr("href",getPurl);
  })

  $(document).on("change", "input#agree-to-subscribe", function(){
    const $submit = $(".custom-newsletter-submit");
    if($(this).is(":checked")) {
      $submit.removeAttr("disabled");
    } else {
      $submit.attr("disabled","disabled");
    }
  })
});